import classNames from "classnames/bind";
import { Text, Button, Picture, Box } from "@smile2impress/components";
import { withCdnUrl } from "@smile2impress/attraction-utils";
import { SYTLegacyTheme } from "@smile2impress/themes";

import Link from "components/Link";
import { MaxWidthContainer } from "components/MaxWidthContainer";
import Container from "components/Container/Container";
import { NestedThemeProvider } from "components/NestedThemeProvider";

import { BlogList } from "./components/BlogList";
import { BlogLayoutProps } from "./BlogLayout.type";
import styles from "./BlogLayout.module.scss";

const cx = classNames.bind(styles);

export const BlogLayout: React.FunctionComponent<BlogLayoutProps> = ({
    content,
}) => {
    const { title, posts, sideBanner, readMoreText, readTimeText } = content;

    return (
        <NestedThemeProvider theme={SYTLegacyTheme}>
            <MaxWidthContainer>
                <Container className={cx("container")}>
                    <section className={cx("main")}>
                        <div className={cx("header")}>
                            <Picture
                                images={{
                                    png: withCdnUrl(
                                        "/images/icons/blog-icon.png"
                                    ),
                                }}
                                defaultSrc={withCdnUrl(
                                    "/images/icons/blog-icon.png"
                                )}
                                className={cx("image")}
                                width={69}
                                height={69}
                            />
                            <Text
                                as="h1"
                                textStyle="title1"
                                color="text.accent"
                            >
                                {title}
                            </Text>
                        </div>

                        <BlogList
                            list={posts}
                            readMoreText={readMoreText}
                            readTimeText={readTimeText}
                        />
                    </section>
                    <Box display="block" pl="15px" w="33.333%">
                        <Box
                            position="relative"
                            w="100%"
                            h="600px"
                            bgRepeat="no-repeat"
                            bgPosition="top center"
                            bgSize="cover"
                            bgImage={sideBanner?.bg}
                        >
                            {sideBanner?.button?.link &&
                                sideBanner?.button?.name && (
                                    <Button
                                        as={Link}
                                        href={sideBanner?.button.link}
                                        pos="absolute"
                                        width="90%"
                                        left="5%"
                                        bottom="5%"
                                    >
                                        {sideBanner?.button?.name}
                                    </Button>
                                )}
                        </Box>
                    </Box>
                </Container>
            </MaxWidthContainer>
        </NestedThemeProvider>
    );
};
